<template>
  <form @submit.prevent='validate_subscribe' :class='{ errors: $v.$error }' novalidate>
    <div class='form-group'>
      <input id='email' type='email' v-model.trim='email' placeholder='Email'>
      <div class='error' v-if='!$v.email.required'>Email is required</div>
      <div class='error' v-if='!$v.email.email'>Email is not the right format</div>
      <div class='error' v-if='!$v.email.maxLength'>Email is too long</div>
    </div>

    <button :disabled='submitting' class='btn'>Subscribe</button>
  </form>
</template>

<script>
  import { email, maxLength, required } from 'vuelidate/lib/validators'

  export default {
    data () {
      return {
        submitting: false,
        email: ''
      }
    },
    validations: {
      email: {
        required,
        email,
        maxLength: maxLength(255)
      }
    },
    methods: {
      validate_subscribe () {
        this.$v.$touch()

        if (!this.$v.$error) {
          this.subscribe()
        }
      },
      subscribe () {
        this.submitting = true

        let body = {
          email: this.email,
          list_id: '22a694be57cc0604cf2218d83464014d',
          referrer: this.$cookie.get('referrer')
        }

        this.$http.post(`/subscribers`, body).then(response => {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'supported_cameras_email_signup', { event_category: 'form' })
          }
          this.$cookie.set('unsupported-camera-email', this.email, 1)
          window.location = '/unsupported-camera'
        }, response => {
          let message = "Something went wrong.  Please try again later."
          this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })
        })
      }
    }
  }
</script>
